module.exports = __webpack_public_path__ + "static/media/remarca-consulta.7ae176de.jpg";